<template>
  <div>
    <el-dialog :visible.sync="selfDialogVisible" :before-close="beforeClose">
      <div
        style="
          width: 100%;
          height: 40px;
          background: #409eff;
          line-height: 40px;
          font-size: 16px;
          font-weight: blod;
          color: #ffffff;
        "
      >
        <span>
          <i class="el-icon-arrow-left"></i>
          <el-link :underline="false" @click="toHome">返回</el-link>
        </span>
      </div>
      <el-container style="padding: 10px 20px">
        <el-aside width="100px">
          <span
            v-for="item in firstList"
            :key="item.tip"
            style="display: block; margin-bottom: 10px"
          >
            <el-link type="primary" @click="changeSet(item.tip)">{{
              item.name
            }}</el-link>
          </span>
        </el-aside>
        <el-divider direction="vertical"></el-divider>
        <el-aside width="100px">
          <span
            v-for="item in secondList[listnum]"
            :key="item.name"
            style="display: block; margin-bottom: 10px"
          >
            <i class="el-icon-s-tools"></i>
            <el-link type="info" @click="goSet(item.tip)">{{
              item.name
            }}</el-link>
          </span>
        </el-aside>
        <el-divider direction="vertical"></el-divider>
        <el-main style="width: 600px; height: 800px; overflow: auto">
          <div
            style="margin-bottom: 10px"
            v-for="item in secondList[listnum]"
            :key="item.name"
          >
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item :name="item.tip">
                <template slot="title">
                  <div>
                    <span style="display: block; margin-bottom: 10px">
                      <i class="el-icon-s-tools"></i>
                      {{ item.name }}
                    </span>
                  </div>
                </template>
                <component :is="item.component"></component>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-main>
      </el-container>
    </el-dialog>

    <!-- <person-center-info
    :dialogVisible="dialogVisibles"
    @updateDialogVisible="updateDialogVisible"
  >
  </person-center-info> -->
  </div>
</template>

<script>
import PersonCenterInfo from './PersonCenterInfo'
import OtherPhone from './OtherPhone'
import OtherAccount from './OtherAccount'
import PlgUnit from './PlgUnit'
export default {
  inject: ['app'],
  props: {
    dialogVisible: {
      type: Boolean,
    },
  },
  components: {
    PersonCenterInfo,
    OtherPhone,
    OtherAccount,
    PlgUnit,
  },
  computed: {
    selfDialogVisible() {
      return this.dialogVisible
    },
  },
  data() {
    return {
      activeName: '1',
      actice: 1,
      dialogVisibles: false,
      // 功能标签
      firstList: [
        {
          name: '个人设置',
          tip: 1,
        },
        {
          name: '系统设置',
          tip: 2,
        },
      ],
      secondList: [
        [
          {
            name: '基本信息',
            component: 'PersonCenterInfo',
            tip: '1',
          },
          {
            name: '三方账户',
            component: 'OtherAccount',
            tip: '2',
          },
          {
            name: '设备绑定',
            component: 'OtherPhone',
            tip: '3',
          },
        ],
        [
          {
            name: '插件管理',
            component: 'PlgUnit',
            tip: '1',
          },
        ],
      ],
      listnum: 0,
    }
  },
  created() {},
  mounted() {},
  methods: {
    changeSet(num) {
      this.listnum = num - 1
    },
    goSet(num) {
      this.activeName = num
    },
    peizhi() {
      this.dialogVisibles = true
    },
    resetForm() {
      this.$refs.userInfo.resetFields()
    },
    toHome() {
      this.$emit('updateDialogVisible')
    },
    updateDialogVisible() {
      this.toHome()
    },
    beforeClose() {
      this.toHome()
    },
  },
}
</script>

<style lang="scss" scoped></style>
